import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import Link from 'components/Link';
import { getFileNameDisplay } from 'util/file';

import classes from './FileNameDisplay.module.scss';

const FileNameDisplay = ({ type, filename, handleOnClick }) => {
  const placement = 'bottom-start';
  let result = <>{filename}</>;

  if (type === 'link') {
    result = (
      <div>
        <Tooltip title={filename} placement={placement}>
          <div className={classes.filename}>
            <Link
              text={getFileNameDisplay(filename)}
              linkProps={{
                onClick: () => handleOnClick(),
              }}
            />
          </div>
        </Tooltip>
      </div>
    );
  }

  if (type === 'item') {
    result = (
      <div>
        <Tooltip title={filename} placement={placement}>
          <div className={classes.filename}>{getFileNameDisplay(filename)}</div>
        </Tooltip>
      </div>
    );
  }

  return result;
};

export default FileNameDisplay;
